import { ElementId } from '~/features/shared/ad/types'

export const pcTopAd: ElementId = 'topAdBigBanner'

export const footer: ElementId = 'gAdftrRectangle'

export const pageBottomPcAds = [
  'adContentBottomLeft',
  'adContentBottomRight',
] satisfies [ElementId, ElementId]
